module.exports = __webpack_public_path__ + "media/hôie dtaai láew.0861c8f0.mp3";